import Delete from './Delete';

export {
  // eslint-disable-next-line import/prefer-default-export
  Delete
};
